import { render, staticRenderFns } from "./Nurse.vue?vue&type=template&id=dff2cc06&scoped=true&"
import script from "./Nurse.vue?vue&type=script&lang=js&"
export * from "./Nurse.vue?vue&type=script&lang=js&"
import style0 from "./Nurse.vue?vue&type=style&index=0&id=dff2cc06&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff2cc06",
  null
  
)

export default component.exports